/* eslint-disable no-nested-ternary */
import React from 'react';
import { Input } from 'reactstrap';

const CustomSelection = ({
  optionsList,
  onChange,
  name,
  filterBy,
  disabled,
  placeholder,
  value,
  customClass,
  defaultOpt,
}) => {
  return (
    <Input
      disabled={disabled}
      type="select"
      name={name || 'selection'}
      onChange={onChange}
      className={customClass || ``}
    >
      {defaultOpt && <option value="">Please select any option</option>}
      {optionsList.map((el, index) => (
        <option
          key={filterBy ? el[filterBy] : el}
          value={placeholder && index === 0 ? '' : filterBy ? el[filterBy] : el}
          selected={value === el}
        >
          {filterBy ? el[filterBy] : el}
        </option>
      ))}
    </Input>
  );
};

export default CustomSelection;
